import { AgGridReactProps } from 'ag-grid-react'

import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'

import { ICReportTablePrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { fundLevel } from '@/react-query/queries/ic-report/hooks'

const columnDefs = createColDefs([
  // { field: "fund_id" },
  { field: 'Return Objective' },
  { field: 'Horizon' },
  { field: 'Volatility Target' },
  { field: 'Correlation Target' },
  { field: 'Beta Target' },
  { field: 'Income Target' },
])

export interface FundLevelTableProps extends ICReportTablePrimitive {}

export const FundLevelTable: React.FC<FundLevelTableProps> = ({ params, options }) => {
  const query = fundLevel.useFundLevel(params)
  const data = query.data ?? []

  const mergedOptions = {
    statusBar: { statusPanels: [] },
    ...options,
  } satisfies AgGridReactProps

  return <CustomAgGrid rowData={data} columnDefs={columnDefs} {...mergedOptions} />
}
